/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MessageStatusFromJSON, MessageStatusToJSON } from './';
export function SetMessageStatusMessageThreadRequestFromJSON(json) {
    return SetMessageStatusMessageThreadRequestFromJSONTyped(json, false);
}
export function SetMessageStatusMessageThreadRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        status: MessageStatusFromJSON(json['status']),
    };
}
export function SetMessageStatusMessageThreadRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        status: MessageStatusToJSON(value.status),
    };
}
